import React from 'react';
import { Translate } from 'react-localize-redux';
import { DealColumn } from '../components/deal-list-column';
import { DealName } from '../components/deal-name';

export const LABEL_DEAL_COLUMNS: DealColumn[] = [
  {
    key: 'label-name',
    label: <Translate id="LABEL.DEALS.LABEL_NAME" />,
    render: (deal) => <DealName deal={deal} />,
    size: 6,
  },
  {
    key: 'split',
    label: <Translate id="LABEL.DEALS.SPLIT" />,
    render: (deal) =>
      `${deal.beneficiaries.reduce((m,b) => m + b.share, 0) / deal.beneficiaries.length}%`,
    size: 2,
    type: 'number',
  },
  {
    key: 'revenue',
    label: <Translate id="LABEL.DEALS.REVENUE" />,
    render: (deal) => deal.revenue.toFormat(),
    size: 2,
    type: 'number',
  },
];
